import useCar from '~/data/hooks/useCar';
import { useComplianceByCarId } from '~/data/hooks/useComplianceByCarId';

/**
 * Which car this is, from the two reads that say so — there is no single per-car
 * endpoint carrying both:
 *
 * - `compliancesRetrieve` — where the car sits and its certificate, jurisdiction,
 *   inspection status and violation counts. Also the only source of `propertyId`.
 * - `carsRetrieve` — the unit record the header shows and the edit dialog writes. Not
 *   date-scoped, which is why the specs come from here.
 *
 * The ticket-derived KPIs are not here: `ElevatorMaintenanceTab` reads them itself,
 * because it owns the period they are of.
 */
export function useElevatorDetail(carId: string | undefined) {
  const { compliance, error, isLoading, mutate } = useComplianceByCarId(carId);
  const { car, loading: carLoading } = useCar(carId);

  return {
    compliance: compliance ?? null,
    car,
    carLoading,
    error,
    isLoading,
    refresh: mutate,
  };
}
